import { useEffect, useState } from 'react';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { GET_COUNT_UNREAD_CONVERSATIONS } from '@/api';
import { inboxService } from '@/api/inbox';
import { useEventSource } from '@/hooks/useEventSource';
import clsx from 'clsx';

export const CounterInbox: React.FC = () => {
	const session = useSession();
	const token = session.data?.accessToken;
	const [number, setNumber] = useState<string>();

	const { data } = useEventSource({
		url: `${process.env.NEXT_PUBLIC_API}/sse/inbox-counter/subscribe?token=${token}`,
	});

	const { data: count } = useQuery({
		queryKey: [GET_COUNT_UNREAD_CONVERSATIONS],
		queryFn: () => inboxService.getUnreadConversationsCounter(),
	});

	useEffect(() => {
		if (!data && count?.data.unread) {
			return setNumber(String(count.data.unread));
		}

		if (data) {
			const value = JSON.parse(data);
			const count = value.payload.data.unreadCount;
			setNumber(String(count));
		}
	}, [count, data]);

	if (!number || number === '0') return <></>;
	return (
		<>
			<div
				className={clsx(
					'bg-main-red rounded-full w-2 h-2 absolute left-[22px] lg:left-[30px] top-1 ring-1 ring-white'
				)}
			/>
		</>
	);
};
